export const OPEN_UI_ELEMENT = 'OPEN_UI_ELEMENT'
export const CLOSE_UI_ELEMENT = 'CLOSE_UI_ELEMENT'
export const CLOSE_ALL_UI_ELEMENTS = 'CLOSE_ALL_UI_ELEMENTS'

